// extracted by mini-css-extract-plugin
export default {"on":"VIPSListActionBar_on__C36dM","off":"VIPSListActionBar_off__JQl2S"};